import OutsideProcessingVendorStatusChip from "./OutsideProcessingVendorStatusChip";
import OutsideProcessingVendorCheckbox from "./OutsideProcessingVendorCheckbox";

const sortable = true;
export const items = [
  {
    id: "customerName",
    label: "Customer",
  },
  {
    id: "workOrder",
    label: "WO #",
    sortable,
  },
  {
    id: "poNumber",
    label: "PO #",
  },
  {
    id: "partNumber",
    label: "Part Number",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "station",
    label: "Station",
  },
  {
    id: "available",
    label: "Available",
  },
  {
    id: "remaining",
    label: "Remaining",
  },
  {
    id: "startDate",
    label: "Start Date",
    sortable,
  },
  {
    id: "status",
    label: "Status",
  },
];

export const keys = [
  {
    value: "isChecked",
    variant: "small",
    CustomComponent: OutsideProcessingVendorCheckbox,
  },
  {
    variant: "blueBold",
    value: "customer.name",
    navigate: true,
    route: "customers",
    id: "customer.id",
  },
  {
    variant: "blueBold",
    value: "workOrder",
    navigate: true,
    route: "works",
    id: "workOrder",
  },
  {
    variant: "blueBold",
    value: "order.poNumber",
    navigate: true,
    route: "orders",
    id: "order.id",
  },
  {
    variant: "blueBold",
    value: "part.partNumber",
    navigate: true,
    route: "parts",
    id: "part.id",
  },
  {
    variant: "blueBold",
    value: "part.partName",
    navigate: true,
    route: "parts",
    id: "part.id",
  },
  {
    value: "station",
  },
  {
    value: "available",
  },
  {
    value: "remaining",
  },
  {
    value: "startDate",
    isDate: true,
  },
  {
    value: "status",
    isChip: true,
    CustomComponent: OutsideProcessingVendorStatusChip,
  },
];
